
import { LiveData, Service } from '@toeverything/infra';
import request from '../server/base';
import { getCookie } from '../server/utils';
import { apiVersion, getCoreUrl, RESPONSE_CODE } from '../server/config';

export interface ICaseListItem {
  caseId: string;
  poster: {
    tag: {
      icon: string;
      title: string;
    };
    title: string;
    cover: string;
    user: {
      name: string;
      avatar: string;
    }
  };
}
export class CaseService extends Service {
  private readonly _list$ = new LiveData<ICaseListItem[]>([]);
  get list$() {
    return this._list$;
  }

  constructor() {
    super();
  }

  setList(newList: ICaseListItem[]) {
    this._list$.next(newList);
  }
  
  async initList(locale: string) {
    let authToken = getCookie('login_token');
    const config = {
      url: `${getCoreUrl(apiVersion)}/showcases`,
      method: 'GET',
      headers: {
        'X-Yuanshi-Locale': locale,
      },
    };
    if (authToken) {
      config.headers['X-Yuanshi-Authorization'] = 'Bearer ' + authToken;
    }
    return request(config);
  }
}
